import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { CourierInfoService } from 'src/app/services/courier-info.service';
import { HomeshoppingDataService } from 'src/app/services/homeshopping-data.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NotificationService } from 'src/app/services/notification-service';
import { UploaddataService } from 'src/app/services/uploaddata.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-manage-application-popup',
  templateUrl: './manage-application-popup.component.html',
  styleUrls: ['./manage-application-popup.component.scss']
})
export class ManageApplicationPopupComponent implements OnInit {
  head: any;
  disaplayType: any
  form: FormGroup
  changeaddressforn: FormGroup
  physicaladdressform: FormGroup

  showEFTBox: boolean = false;
  selectedFile: File | null = null;

  displayedColumns: string[] = [
    "UpdatedOn",
    "Status",
    "DoneBy",
  ];
  displayedColumns1: string[] = [
    "LineItem",
    "ProductName",
    "SerialNo",
  ];
  displayedColumns2: string[] = [
    "Type",
    "Date",
    "FileName",
    "action"
  ];
  dataSource = new MatTableDataSource(null);
  isConsolidate: any
  serviceQueue: any;
  CourierList: any
  region: any;
  city: any;
  country: any;
  dispatchDetailslist: any;
  disablePrint = true
  value: any;
  orderLineItemId: any;
  shipLogicGettingratesList: any
  selectedCardCode: any;
  date = new Date()
  mindate = new Date(this.date);
  fileremoved = false
  file: File;
  fileName: string = '';
  isFileSelected = false
  FileExtention: string;
  filedate: any;
  enableuploadbtn = true
  sanitizedUrl: SafeResourceUrl
  show: boolean = false
  filteredList: any;
  filteredList1: any;
  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<ManageApplicationPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private courierInfoService: CourierInfoService,
    private lookupDataService: LookupDataServiceService,
    private homeshoppingDataService: HomeshoppingDataService,
    private matdialog: MatDialog,
    private toast: NotificationService,
    private uploadDataService: UploaddataService,
    private applicationDataService: ApplicationDataService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    console.log(this.data);

    this.form = this.formBuilder.group({
      comment: [null, Validators.pattern(/^\S.*/)],
      creditvetreason: [],
      courierId: [1],
      accountNumber: [],
      serial: [],
      serialno: this.formBuilder.array([]),
      deviceComments: [],
      courierComments: [],
      addressLine1: [],
      addressLine2: [],
      cityId: [],
      region: [],
      country: [1],
      pincode: [],
      code: [],
      adminapprovedate: [],
      requestedDate: [],
      cancelDate: [],

    })
    this.changeaddressforn = this.formBuilder.group({
      addressLine1: [],
      addressLine2: [],
      suburb: [],
      city: [],
      region: [],
      pincode: [],
    })
    this.physicaladdressform = this.formBuilder.group({
      unitNumber: [],
      complexName: [],
      streetNumber: [],
      streetName: [],
      suburb: [],
      city: [],
      postalCode: [],
      province: [],
      countryCode: [],
    })

    this.head = this.data.title
    this.disaplayType = this.data.head
    if (this.disaplayType == 'physicaladdress')
      this.physicaladdressform.patchValue(this.data.data)
    if (this.disaplayType == 'history')
      this.dataSource = new MatTableDataSource(this.data.data);
    if (this.disaplayType == 'print') {
      console.log(this.data);

      this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(this.data.data));
    }
    if (this.disaplayType == 'shippment') {
      this.isConsolidate = this.data.isConsolidate
      this.dispatchDetailslist = this.data.data
      if (this.isConsolidate == true) {
        const serialno = this.form.get('serialno') as FormArray;
        serialno.clear();
        this.dispatchDetailslist.forEach(item => {
          serialno.push(new FormControl(item.serialno, [Validators.required]));
        });
        this.dataSource = new MatTableDataSource(this.data.data);
        this.orderLineItemId = this.dispatchDetailslist[0].orderLineItemId;
      } else
        this.orderLineItemId = this.dispatchDetailslist.orderLineItemId;
      this.form.get('accountNumber').setValue(this.dispatchDetailslist.accountNumber == null ? 'CHC001' : this.dispatchDetailslist.accountNumber)

      this.getshippmentdata()
    }

    if (this.disaplayType == 'address') {
      this.value = this.data.data
      this.filteredList = this.value[0];
      this.filteredList1 = this.value[1];

      this.orderLineItemId = this.data.orderLineItemId
    }

    if (this.disaplayType == 'rates')
      this.shipLogicGettingratesList = this.data.data
    if (this.disaplayType == 'transferapprove') {
      this.form.get('requestedDate').setValue(this.data.requestedDate)
      this.mindate.setDate(this.mindate.getDate() + 1);

    }

    //transferdoc
    if (this.disaplayType == 'transferdoc') {
      let value = this.data
      this.dataSource = new MatTableDataSource(value.data)
    }
    if (this.disaplayType == 'eftDocs') {
      let value = this.data
    }

  }

  Close() {
    this.dialogRef.close();
  }
  //rejectcommand
  Submit() {
    if (this.disaplayType == 'rejectcommand') {
      const commentControl = this.form.get('comment');
      if (this.form.value.comment && commentControl.valid) {
        if ((this.data?.data?.serviceProviderId == '36' || this.data?.data?.serviceProviderId == '24') && !this.form.value.creditvetreason) {
          this.form.get('creditvetreason').setErrors({ required: true })
          this.show = true
        }
        else if (this.form.value.creditvetreason) {
          var value: any = { comment: this.form.value.comment, creditvetreason: this.form.value.creditvetreason }
          this.dialogRef.close(value)
        }
        else
          this.dialogRef.close(this.form.value.comment)
      }
      else {
        this.form.get('comment').setErrors({ required: true });
        this.toast.showError("Please fill the require fields!")
      }
    }
    else {
      if (this.form.value.comment) {
        let privateComments: any = {}
        privateComments = this.data.data
        privateComments.applicationNotesMapping = [];
        privateComments.description = this.form.value.comment;
        privateComments.applicationNotesMapping.push({
          ApplicationStatus: privateComments.applicationStatus,
          ApplicationId: privateComments.applicationId
        });
        this.dialogRef.close(privateComments)

      }
    }
  }
  //shipment
  async getshippmentdata() {
    this.serviceQueue = [
      firstValueFrom(this.courierInfoService.getCourierList()),
      firstValueFrom(this.lookupDataService.getRegionTypeList(true)),
      firstValueFrom(this.lookupDataService.getAllCity()),
      firstValueFrom(this.lookupDataService.getCountryType(true)),
    ]
    const response = await Promise.all(this.serviceQueue)
    this.CourierList = response[0]
    this.region = response[1]
    this.city = response[2];
    this.country = response[3];
  }

  get availableControls(): any {
    return (this.form.get('serialno') as FormArray).controls;
  }

  saveShipmentForm() {
    if (!this.isConsolidate) {

      let data = this.form.value
      let value = { courierId: data.courierId, accountNumber: data.accountNumber, serial: data.serial, deviceComments: data.deviceComments, courierComments: data.courierComments }
      this.dialogRef.close(value)
    }
    else {
      const serialnoArray = this.form.get('serialno') as FormArray;
      serialnoArray.controls.forEach(control => control.setErrors(null));

      let hasError = false;
      serialnoArray.controls.forEach((control) => {
        if (control.value === null || control.value === "") {
          control.setErrors({ zeroError: true });
          hasError = true;
        }
      });
      serialnoArray.markAllAsTouched();
      if (hasError || this.form.invalid) {
        return;
      }
      this.dispatchDetailslist.forEach((item, index) => {
        item.serial = serialnoArray.at(index).value;
      });
      let data = this.form.value
      let value: any = {
        courierId: data.courierId, accountNumber: data.accountNumber, courierComments: data.courierComments
      }
      //   this.dispatchDetailslist = {...this.dispatchDetailslist,...value}
      this.dispatchDetailslist = [{
        ...value,
        ...this.dispatchDetailslist
      }]
      console.log(this.dispatchDetailslist);
      this.dialogRef.close(this.dispatchDetailslist[0])
    }
  }

  amendAddres() {
    const dialogref = this.matdialog.open(ManageApplicationPopupComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'mat-dialog',
      width: "50%",
      data: {
        title: 'Amend Shopping Address',
        head: 'address',
        data: [this.city, this.region, this.country],
        orderLineItemId: this.orderLineItemId
      }
    });

  }

  print() {
    this.homeshoppingDataService.getShoppingOrderAddressPDF(this.orderLineItemId).subscribe((result) => {
      this.disablePrint = false
      this.disablePrint = false
      const dialogref = this.matdialog.open(ManageApplicationPopupComponent, {
        autoFocus: false,
        disableClose: true,
        panelClass: 'mat-dialog',
        width: '1200px',
        height: '825px',
        data: {
          title: 'Amend Address',
          head: 'print',
          data: result
        }

      });
    })

  }

  //address
  regionchange() {
    if (this.form.value.region) {
      this.lookupDataService.getCityByRegionType(this.form.value.region).subscribe((result) => {
        this.value[1] = result
      })
    }
  }

  saveCustomerDetailsForm() {
    let value = this.form.value
    if (value.addressLine1 && value.addressLine2 && value.region && value.country && value.cityId) {
      var postData: any = {};
      postData.addressLine1 = value.addressLine1
      postData.addressLine2 = value.addressLine2
      postData.region = value.region
      postData.cityId = value.cityId
      postData.country = value.country
      postData.pincode = value.pincode
      postData.orderLineItemId = this.orderLineItemId;

      this.homeshoppingDataService.updateShoppingAddress(postData).subscribe((result) => {
        this.toast.showSuccess('updated successfully')
        this.dialogRef.close()
      })
    }
  }

  //rates
  selected(code) {
    this.form.get('code').setValue(code)
    this.selectedCardCode = code
    console.log(this.form.value.code);

  }
  ratesSubmit() {
    if (this.form.value.code)
      this.dialogRef.close(this.form.value.code)
  }

  //transferapprove
  transferapproveSubmit() {
    let value = this.form.value.adminapprovedate
    this.dialogRef.close(value)
  }

  //transferdoc
  selectfile(data: any) {
    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.style.display = 'none';
    document.body.appendChild(inputElement);
    inputElement.click();

    inputElement.addEventListener('change', async (event: any) => {
      const files: FileList = (event.target as HTMLInputElement).files;

      if (!files || files.length === 0) {
        Swal.fire('Warning', 'Please upload a file', 'warning');
        return;
      }
      if (files.length > 1) {
        Swal.fire('Warning', 'Please upload only one file at a time', 'warning');
        return;
      }

      this.file = files[0];
      this.fileName = this.file.name;
      const fileExtension = this.fileName.split('.').pop().toLowerCase();
      const validExtensions = ['png', 'jpeg', 'jpg', 'pdf', 'doc', 'docx'];
      const validMimeTypes = [
        'image/png',
        'image/jpeg',
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      ];
      const isValidExtension = validExtensions.includes(fileExtension);
      const isValidMimeType = validMimeTypes.includes(this.file.type);
      if (!isValidExtension || !isValidMimeType) {
        Swal.fire(
          'Warning',
          `Please upload a correct file format (png, jpeg, jpg, pdf, doc, docx)`,
          'warning'
        );
        this.fileName = '';
        this.isFileSelected = false;
        document.body.removeChild(inputElement);
        return;
      }
      this.filedate = this.formatDate(new Date());

      this.FileExtention = fileExtension;
      this.isFileSelected = true;
      console.log(this.file);
      document.body.removeChild(inputElement);
      this.enableuploadbtn = false
      console.log(this.data);

      data.action = false
      data.documentTypeString = this.data.data[0].documentTypeString
      data.uploadedDate = this.filedate
      data.fileName = this.fileName
      this.dataSource = new MatTableDataSource(this.data.data)
    });
  }
  formatDate(date: Date) {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };
    return date.toLocaleString('en-US', options).replace(',', '');
  }

  upload() {
    let formdata: FormData = new FormData()
    formdata.append('documentType', this.data.documentType)
    formdata.append('customerApplicationId', this.data.applicationId)
    formdata.append('file', this.file)


    this.uploadDataService.getCustomerDocumentFileUploaderInstance(formdata).subscribe((result) => {
      this.toast.showSuccess('File Upload Successfully')
      this.dialogRef.close(true)
    })

  }

  reset() {
    const txt = 'Are you sure want to delete?';
    const Yes = 'Yes';
    const No = 'No';
    Swal.fire({
      text: txt,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#7D32DE',
      cancelButtonColor: '#23C00A',
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then((result) => {
      if (result.value) {
        this.fileName = "";
        this.isFileSelected = false;
        this.selectedFile = null;

      }
    });
  }

  Removefile(data) {
    if (this.fileremoved) {
      data.action = true
      data.uploadedDate = ''
      data.fileName = ''
    }
    else {
      const txt = 'Do you want to Remove this File ?';
      const Yes = 'Yes';
      const No = 'No';
      Swal.fire({
        text: txt,
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#7D32DE',
        cancelButtonColor: '#23C00A',
        confirmButtonText: Yes,
        cancelButtonText: No,
      }).then((result) => {
        if (result.value) {
          this.uploadDataService.delteCustomerDocument(data.id).subscribe((result) => {
            data.action = true
            data.uploadedDate = ''
            data.fileName = ''
            this.fileremoved = true
            this.enableuploadbtn = true
            console.log(this.data);

            this.toast.showSuccess('Deleted Successfully')
          })
        }

      })
    }
  }

  approveWithoutUpload() {
    let formdata: FormData = new FormData()
    formdata.append('documentType', this.data.documentType)
    formdata.append('customerApplicationId', this.data.applicationId)
    formdata.append('file', this.file)


    this.uploadDataService.getCustomerDocumentFileUploaderInstance(formdata).subscribe((result) => {
      this.toast.showSuccess('File Upload Successfully')
      this.dialogRef.close(true)
    })

  }

  //confirmation
  canceldate() {
    this.dialogRef.close(this.form.value.cancelDate)
  }

  //addresschange
  addresschange() {
    this.dialogRef.close(this.changeaddressforn.value)
  }
  physicaladdresssave() {
    this.dialogRef.close(this.physicaladdressform.value)
  }
  onFileSelected(event?: any) {
    let file: File | null = null;

    if (event && event.target && event.target.files.length > 0) {
      file = event.target.files[0];
    }
    var fileExtension = this.fileName.slice(
      this.fileName.lastIndexOf('.') + 1
    );
    var type =
      '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
    var result =
      '|jpg|pdf|jpeg'.indexOf(type) !== -1 ||
      '|jpg|pdf|jpeg|'.indexOf(fileExtension) !== -1;

    if (!result) {
      Swal.fire(
        'Warning',
        `Please upload a Correct File Format (jpg, jpeg, pdf)`,
        'warning'
      );

      this.fileName = '';
      this.isFileSelected = false;
      this.selectedFile = null;
    
      return;
    }

    if (file) {
      this.selectedFile = file;
      this.fileName = file.name;
      this.isFileSelected = true;

    }
  }

  uploadEFT() {
    let formdata: FormData = new FormData();
    formdata.append('documentType', this.data.documentType);
    formdata.append('customerApplicationId', this.data.applicationId);
    formdata.append('file', this.selectedFile);
    if (this.selectedFile) {
      this.uploadDataService.getCustomerDocumentFileUploaderInstance(formdata)
        .subscribe((result) => {
          if (result)
            this.dialogRef.close(true);

          else
            this.dialogRef.close(false);
        });
    }
    else
      this.dialogRef.close(true);
  }
}
